import { Button } from '@fluentui/react-components';
import { useTranslation } from 'react-i18next';

// src: https://www.andiamo.co.uk/resources/iso-language-codes/
type AvailableLanguagesISO639_1LanguageCodes = 'en-GB' | 'fr-FR' | 'de-DE';

export default function LanguageSelector() {
  const { i18n } = useTranslation();
  const languageOptions: AvailableLanguagesISO639_1LanguageCodes[] = ['en-GB', 'de-DE', 'fr-FR'];

  return (
    <menu style={{ display: 'flex', gap: 12, listStyle: 'none' }}>
      {languageOptions.map((l) => (
        <li key={l}>
          <Button
            appearance="subtle"
            style={{
              fontWeight: i18n.language === l ? 'bold' : 'normal',
              minWidth: 'auto',
            }}
            onClick={() => i18n.changeLanguage(l)}
          >
            {l.toUpperCase().split('-').shift()}
          </Button>
        </li>
      ))}
    </menu>
  );
}
